import { io, Socket } from "socket.io-client";
import { accosyncIpConfig } from "./ipconfig";

let socket: Socket | null = null;

export const getSocket = (): Socket | null => {
    return socket;
};

export const socketInitiate = (): Socket => {
    if (socket) {
        console.log("INTERNAL Socket: Already initiated.");
        return socket;
    }

    socket = io(accosyncIpConfig, {
        auth: {
            pass: "stongpasshere"
        },
        autoConnect: true,
        reconnection: true,
        reconnectionAttempts: Infinity,
        reconnectionDelay: 1000,
        reconnectionDelayMax: 5000,
        timeout: 20000
    });

    socket.on("connect", () => {
        console.log("\x1b[32m%s\x1b[0m", `INTERNAL Socket connected: ${socket?.id}`);
    });

    socket.on("disconnect", (reason) => {
        const socketId = socket ? socket.id : "unknown";
        console.log("\x1b[31m%s\x1b[0m", `INTERNAL Socket disconnected: ${socketId} Reason: ${reason}`);
    });

    socket.on("connect_error", (error) => {
        console.error("\x1b[31m%s\x1b[0m", `INTERNAL Socket connection error: ${error.message}`);
    });

    socket.on("reconnect_attempt", (attempt) => {
        console.log(`INTERNAL Socket reconnecting... (Attempt ${attempt})`);
    });

    return socket;
};
